// extracted by mini-css-extract-plugin
export var columnList = "_fz-0";